(() => {
  function closestIndexByScrollLeft(list, slides) {
    const x = list.scrollLeft;

    let bestIdx = 0;
    let bestDist = Infinity;

    slides.forEach((slide, idx) => {
      // offsetLeft is relative to offsetParent; in Dawn this is stable for slider items
      const dist = Math.abs(slide.offsetLeft - x);
      if (dist < bestDist) {
        bestDist = dist;
        bestIdx = idx;
      }
    });

    return bestIdx;
  }

  function init(root) {
    const slider = root.querySelector('slider-component');
    if (!slider) return;

    const list = slider.querySelector('.product__media-list');
    if (!list) return;

    const slides = Array.from(list.querySelectorAll('.product__media-item'));
    if (slides.length <= 1) return;

    // ✅ Anchor overlay to the SLIDER VIEWPORT (not thumbnails, not a single slide)
    // In Dawn this wrapper exists on mobile; fallback to list parent.
    const viewport =
      slider.querySelector('.slider-mobile-gutter') ||
      list.parentElement ||
      slider;

    viewport.style.position = viewport.style.position || 'relative';

    // Remove any existing dots (handles theme re-renders)
    viewport.querySelectorAll('.oai-gallery-dots').forEach((el) => el.remove());

    // Create dots
    const dots = document.createElement('div');
    dots.className = 'oai-gallery-dots';

    const dotButtons = slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'oai-dot';
      b.setAttribute('aria-label', `Go to image ${i + 1}`);

      b.addEventListener('click', () => {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });

      dots.appendChild(b);
      return b;
    });

    viewport.appendChild(dots);

    function setActive(idx) {
      dotButtons.forEach((btn, i) => btn.classList.toggle('is-active', i === idx));
    }

    // Initial active
    setActive(closestIndexByScrollLeft(list, slides));

    // Update on scroll (swipe)
    let raf = null;
    list.addEventListener(
      'scroll',
      () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          setActive(closestIndexByScrollLeft(list, slides));
        });
      },
      { passive: true }
    );

    // Update on resize
    window.addEventListener('resize', () => {
      setActive(closestIndexByScrollLeft(list, slides));
    });
  }

  function boot() {
    // Product root varies; this covers most Dawn setups
    document.querySelectorAll('section[id^="MainProduct-"], .product').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();